<lgb-header-gradient [background]="true"></lgb-header-gradient>
<div class="screen-container" [loading]="loading()">
	<h1 class="mb-4">Proxies</h1>

	<ul class="list bg-base-100 rounded-box shadow-md">
	  <li class="header-container p-4 pb-2 text-xs opacity-60 tracking-wide">
	  	<span>Liste des proxies</span>
		<a [routerLink]="router.get('proxy-add')" class="btn btn-square btn-ghost add-btn text-primary">
			<i class="fa-regular fa-layer-plus"></i>
		</a>
	  </li>
	  
	  @for(proxy of proxies(); track proxy.ref){
		  <li class="element-show list-row" [style.--i]="$index">
		    <div class="list-row-element">
		      	<div class="inline-grid *:[grid-area:1/1]">
				  <div [ngClass]="statutClass(proxy)" class="status animate-ping"></div>
				  <div [ngClass]="statutClass(proxy)" class="status"></div>
				</div>
		    </div>
		    <div class="list-row-element">
		      <div>{{proxy.ref}}</div>
		    </div>
		    <div class="list-row-element">
		      <div>{{proxy.name}}</div>
		      <div class="text-xs uppercase font-semibold opacity-60">{{proxy.lastActivity | date:'dd/MM/yyyy HH:mm'}}</div>
		    </div>
		    <a href="#" [routerLink]="router.parse('proxy-form', [proxy.ref])" class="btn btn-square btn-ghost">
		    	<i class="text-primary fa-regular fa-pen"></i>
		    </a>
		    <a (click)="removeProxy(proxy)" class="btn btn-square btn-ghost">
		    	<i class="text-error fa-light fa-trash-can"></i>
		    </a>
		  </li>
	  }
	  @empty{
	  	 <li class="list-row">
		    <div>
		      <div>Aucun proxy</div>
		  </div>
		</li>
	  }
	</ul>
</div>
